export type TeamMember = {
  name: string;
  role: string;
  image: string;
  bio: string;
};

export const teamMembers: TeamMember[] = [
  {
    name: "Nils-Andre Stritt",
    role: "Gründer & Medizinstudent",
    image: "/images/team-nils.png",
    bio: "Medizinstudent und Mitgründer von ncrechner. Nils kennt die Herausforderungen des Zulassungsverfahrens aus eigener Erfahrung und hatte die ursprüngliche Idee, die komplexen Auswahlverfahren der Universitäten in einem einfachen Tool abzubilden.",
  },
  {
    name: "Lennart Frederic Flehinghaus",
    role: "Gründer & Arzt",
    image: "/images/team-lennart.png",
    bio: "Arzt und Mitgründer von ncrechner. Lennart hat den Weg von der Studienplatzsuche bis zum abgeschlossenen Medizinstudium selbst durchlaufen und ncrechner von Beginn an maßgeblich mitentwickelt und gestaltet.",
  },
  {
    name: "Arwin Esmaylzadeh",
    role: "Gründer & Physiker",
    image: "/images/team-arwin.png",
    bio: "Physiker und Mitgründer von ncrechner. Arwin brachte von Anfang an seine analytische und naturwissenschaftliche Perspektive in die Entwicklung ein und half dabei, aus komplexen Zulassungsregeln eine verständliche Berechnung zu machen.",
  },
];
